import http from './httpClient';

export default {
  async login(username, password) {
    try {
      const result = await http.post('/api-token-auth/', {
        username,
        password,
      });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  /**
   * Verifica na base de dados se esse e-mail já esta sendo usado por outro usuário.
   * @param {String} username
   */
  async checkEmail(username) {
    try {
      const result = await http.post('/users/check_username/', { username });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Pega a lista de paginas staticas.
   * (Termo de uso, politica de privacidade,...);
   */
  async listPageStatic() {
    try {
      const { data } = await http.get('/static_pages/');
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Retorna dados da pagina statica que foi solicitada pelo id.
   * (Termo de uso, politica de privacidade,...);
   * @param {String} id
   */
  async pageStatic(id) {
    try {
      const { data } = await http.get(`/static_pages/${id}`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async sendHelp(name, email, category, text) {
    try {
      const response = await http.post('/users/send_support_message/', {
        name,
        email,
        category,
        text,
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async sendPartner(name, email, category, text) {
    try {
      const response = await http.post('/users/send_new_partner_message/', {
        name,
        email,
        category,
        text,
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getFirstAppointments() {
    try {
      const result = http.get('/check_chief_therapist_appointment/', {
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getAppointmentsFilter(dataParams) {
    try {
      const res = await http.get('/appointments-filter/',
        {
          params: {
            date__gte: dataParams.initialDate,
            date__lte: dataParams.finalDate,
            search: dataParams.name,
            size: 12,
            page: dataParams.page,
          },
          headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
        },
      );
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getAppointmentDetail(idAppointment) {
    try {
      const result = http.get(`/appointments/${idAppointment}`, {
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
